{
    "CxiLicenceType_SOLO": "Solo",
    "CxiLicenceType_TEAMS": "Équipes",
    "CxiLicenceType_CXI": "Intégration CX",
    "CxiLicenceType_NONE": "Aucun",
    "NAME": "CxiLicenceTypes"
}